import styled from 'styled-components';

const ListContainer = styled.div`
  background: white;
  padding: 1rem;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
`;

type Props = {
  contracts: { label: string; value: number }[];
};

export const ContractList = ({ contracts }: Props) => {
  return (
    <ListContainer>
      <h4>Contracts</h4>
      <ul>
        {contracts.map((c, i) => (
          <li key={i}>{c.label}: {c.value}</li>
        ))}
      </ul>
    </ListContainer>
  );
};
